import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AIThinkingOverlay = _resolveComponent("AIThinkingOverlay")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _ctx.zhCN,
    theme: {
        token: {
          colorPrimary: '#5178c6'
        },
      },
    "component-config": _ctx.componentConfig
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(_component_AIThinkingOverlay, {
        ref: "aiThinkingRef",
        onComplete: _ctx.onAIThinkingComplete,
        onStep9Complete: _ctx.onStep9Complete,
        loadStatus: _ctx.showAnimation,
        "api-completed": _ctx.apiCompleted,
        "detail-data-loaded": _ctx.detailDataLoaded,
        "start-step-index": _ctx.startStepIndex
      }, null, 8, ["onComplete", "onStep9Complete", "loadStatus", "api-completed", "detail-data-loaded", "start-step-index"]),
      (_ctx.$store.state.loading !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_spin, { size: "large" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale", "component-config"]))
}